export default __webpack_public_path__ + "static/media/kitchen5-beforeD.43fe2927.jpg";